import { forwardRef, type ForwardedRef, type InputHTMLAttributes } from "react";

interface FloatingLabelInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  defaultValue?: string;
  error?: string;
  className?: string;
}

const FloatingLabelInputBase = (
  {
    id,
    label,
    defaultValue,
    value,
    onChange,
    error,
    className = "",
    ...rest
  }: FloatingLabelInputProps,
  ref: ForwardedRef<HTMLInputElement>
) => {
  const isControlled = value !== undefined;
  return (
    <div className="relative w-full">
      <input
        id={id}
        ref={ref}
        defaultValue={!isControlled ? defaultValue : undefined}
        value={isControlled ? value : undefined}
        onChange={onChange}
        placeholder=" "
        className={`peer form-control block w-full rounded-md border border-white bg-white px-7 pt-[26px] pb-2.5 text-base text-gray-900
            placeholder-transparent
            focus:border-[#8c8d90] focus:outline-none focus:ring-4 focus:ring-[rgba(24,26,32,0.25)]
            ${error ? "border-red-500" : ""} ${className}`}
        {...rest}
      />
      <label
        htmlFor={id}        
        className="pointer-events-none absolute pl-[17px] pr-7 pb-4 left-3 top-2 text-sm transition-all
    peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-[#181a20]
    peer-focus:top-2 peer-focus:text-sm peer-focus:opacity-65 peer-not-placeholder-shown:opacity-65
  "
      >
        {label}
      </label>
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};

export const FloatingLabelInput = forwardRef<
  HTMLInputElement,
  FloatingLabelInputProps
>(FloatingLabelInputBase);

FloatingLabelInput.displayName = "FloatingLabelInput";

export default FloatingLabelInput;
